module.exports = __webpack_public_path__ + "213ae64b.svg";